"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAnalyticsUserConsent = exports.removeAllEmptiesFrom = void 0;
const removeAllEmptiesFrom = (payload) => {
    const withoutEmpties = {};
    if (Array.isArray(payload)) {
        return payload;
    }
    Object.keys(payload).forEach((key) => {
        if (payload[key] === Object(payload[key])) {
            withoutEmpties[key] = (0, exports.removeAllEmptiesFrom)(payload[key]);
        }
        else if (isDefined(payload[key])) {
            withoutEmpties[key] = payload[key];
        }
    });
    return withoutEmpties;
};
exports.removeAllEmptiesFrom = removeAllEmptiesFrom;
const isDefined = (value) => {
    return typeof value !== "undefined" && value !== null;
};
const hasAnalyticsUserConsent = () => {
    const localStorageValue = localStorage.getItem("ot_userConsent");
    if (localStorageValue !== null) {
        const cookieConsents = JSON.parse(localStorageValue);
        if (cookieConsents.includes("analytics") && isStorebrandDomain()) {
            return true;
        }
    }
    return false;
};
exports.hasAnalyticsUserConsent = hasAnalyticsUserConsent;
const isStorebrandDomain = () => {
    if (location.hostname === "www.storebrand.no") {
        return true;
    }
    if (location.hostname === "www.intra.storebrand.no") {
        return true;
    }
    if (location.hostname === "www.partners.storebrand.no") {
        return true;
    }
    if (location.hostname === "investor.storebrand.no") {
        return true;
    }
    return false;
};
//# sourceMappingURL=utils.js.map